import React from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import { useGameSummaryContext } from "../contexts/GameSummary";

import { selectSelectedTeam } from "../../../../../features/clubhouse/clubhouseSlice";
import { useAppSelector } from "../../../../../hooks/reduxHooks";
import { defaultDateFormat, defaultTimeFormat } from "../../../../../lib/utils";

const GameDetails = (): React.ReactNode => {
    const { game } = useGameSummaryContext();
    const team = useAppSelector(selectSelectedTeam);

    const opposingTeam = team
        ? game.home.id === team?.id
            ? game.visitor
            : game.home
        : undefined;

    return (
        <section className="gameDetails" data-testid="gameDetails">
            <h3>Game Details</h3>
            <Table className="gameDetailsTable">
                <thead>
                    <tr>
                        <th
                            style={{ textAlign: "left" }}
                            colSpan={opposingTeam ? 1 : 2}
                        >
                            {game.visitor.name} @ {game.home.name}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td
                            className="bg-body-secondary"
                            colSpan={opposingTeam ? 1 : 2}
                        >
                            {defaultDateFormat.format(new Date(game.date))}
                            {` @ `}
                            {defaultTimeFormat.format(new Date(game.date))}
                            {` / `}
                            <Link
                                to={`/fields/${game.fieldId}`}
                                target="_blank"
                            >
                                {game.fieldName}
                                {game.diamond
                                    ? `: Diamond: ${game.diamond}`
                                    : ""}
                            </Link>
                        </td>
                    </tr>
                    <tr>
                        {opposingTeam ? (
                            <td>
                                <b>Opposing Coach</b>
                                <br />
                                {`${opposingTeam.coach.firstName} ${opposingTeam.coach.lastName}`}
                                <br />
                                <a
                                    href={`mailto:${opposingTeam.coach.email}`}
                                >{`${opposingTeam.coach.email}`}</a>
                                <br />
                                tel: {opposingTeam.coach.phone}
                            </td>
                        ) : (
                            <>
                                <td width={"50%"}>
                                    <b>{game.visitor.name} Coach</b>
                                    <br />
                                    {`${game.visitor.coach.firstName} ${game.visitor.coach.lastName}`}
                                    <br />
                                    <a
                                        href={`mailto:${game.visitor.coach.email}`}
                                    >{`${game.visitor.coach.email}`}</a>
                                    <br />
                                    tel: {game.visitor.coach.phone}
                                </td>
                                <td width={"50%"}>
                                    <b>{game.home.name} Coach</b>
                                    <br />
                                    {`${game.home.coach.firstName} ${game.home.coach.lastName}`}
                                    <br />
                                    <a
                                        href={`mailto:${game.home.coach.email}`}
                                    >{`${game.home.coach.email}`}</a>
                                    <br />
                                    tel: {game.home.coach.phone}
                                </td>
                            </>
                        )}
                    </tr>
                </tbody>
            </Table>
        </section>
    );
};

export default GameDetails;
